export var SuperluminLight = {
    primaryBase: 'rgba(82, 114, 156, 1)',
    primaryOn: 'rgb(255, 255, 255)',
    primaryVariant: 'rgb(57, 80, 109)',
    primaryVariantOn: 'rgb(255, 255, 255)',
    secondaryBase: 'rgba(69, 95, 130, 1)',
    secondaryOn: 'rgb(255, 255, 255)',
    secondaryVariant: 'rgb(48, 67, 91)',
    secondaryVariantOn: 'rgb(255, 255, 255)',
    highlightBase: 'rgba(49, 67, 92, 1)',
    highlightOn: 'rgb(255, 255, 255)',
    highlightVariant: 'rgb(34, 47, 64)',
    highlightVariantOn: 'rgb(255, 255, 255)',
    dangerBase: 'rgba(244, 67, 54, 1)',
    dangerOn: 'rgb(0, 0, 0)',
    dangerVariant: 'rgb(198, 24, 11)',
    dangerVariantOn: 'rgb(255, 255, 255)',
    warningBase: 'rgba(250, 117, 43, 1)',
    warningOn: 'rgb(0, 0, 0)',
    warningVariant: 'rgb(200, 75, 5)',
    warningVariantOn: 'rgb(255, 255, 255)',
    successBase: 'rgba(76, 173, 80, 1)',
    successOn: 'rgb(0, 0, 0)',
    successVariant: 'rgb(53, 121, 56)',
    successVariantOn: 'rgb(255, 255, 255)',
    infoBase: 'rgba(227, 228, 231, 1)',
    infoOn: 'rgb(0, 0, 0)',
    infoVariant: 'rgb(153, 157, 168)',
    infoVariantOn: 'rgb(0, 0, 0)',
    mainBackground: 'rgba(208, 211, 216, 1)',
    mainOn: 'rgb(0, 0, 0)',
    mainVariantBackground: 'rgb(139, 146, 158)',
    mainVariantOn: 'rgb(0, 0, 0)',
    ribbonBackground: 'rgba(82, 114, 156, 1)',
    ribbonOn: 'rgb(255, 255, 255)',
    ribbonVariantBackground: 'rgb(57, 80, 109)',
    ribbonVariantOn: 'rgb(255, 255, 255)',
    ribbonBreadcrumbBackground: 'rgb(57, 80, 109)',
    ribbonBreadcrumbOn: 'rgb(255, 255, 255)',
    ribbonBreadcrumbVariantBackground: 'rgb(69, 96, 131)',
    ribbonBreadcrumbVariantOn: 'rgb(255, 255, 255)',
    ribbonBorder: 'rgb(57, 80, 109)',
    topnavBackground: 'rgba(23, 38, 60, 1)',
    topnavOn: 'rgb(255, 255, 255)',
    topnavVariantBackground: 'rgb(16, 27, 42)',
    topnavVariantOn: 'rgb(255, 255, 255)',
    topnavTitleBackground: 'rgb(16, 27, 42)',
    topnavTitleOn: 'rgb(255, 255, 255)',
    sidenavBackground: 'rgba(23, 38, 60, 1)',
    sidenavOn: 'rgba(208, 211, 216, 1)',
    sidenavVariantBackground: 'rgba(82, 114, 156, 1)',
    sidenavVariantOn: 'rgb(255, 255, 255)',
    sidenavOpenBackground: 'rgb(35, 57, 90)',
    sidenavOpenOn: 'rgb(255, 255, 255)',
    sidenavBorder: 'rgb(57, 80, 109)',
    surfaceBackground: 'rgb(254, 254, 255)',
    surfaceOn: 'rgb(0, 0, 0)',
    surfaceBorder: 'none',
    scrollbarThumb: 'rgba(23, 38, 60, 1)',
    scrollbarTrack: 'rgba(82, 114, 156, 1)',
    formControlBackground: 'rgba(247, 247, 247, 1)',
    formControlOn: 'rgb(0, 0, 0)',
    formControlBorder: 'rgba(168, 168, 168, 1)',
    formControlHoverBorder: 'rgb(0, 0, 0)',
    formControlIcon: 'rgba(168, 168, 168, 1)',
    formControlHoverIcon: 'rgb(255, 255, 255)',
    formControlLabel: 'rgb(0, 0, 0)',
    formControlLabelCase: 'normal',
    formControlLabelSize: '1rem',
    formControlLabelLetterSpacing: 'unset',
    formControlPlaceholder: 'rgb(135, 135, 135)',
    formControlHint: 'rgb(0, 0, 0)',
    checkboxRadioBackground: 'rgb(0, 0, 0)',
    checkboxRadioHoverBackground: 'rgb(0, 0, 0)',
    sliderBar: 'rgba(247, 247, 247, 1)',
    sliderBarSelected: 'rgb(0, 0, 0)',
    sliderHandle: 'rgb(0, 0, 0)',
    modalBackground: 'rgb(208, 211, 216)',
    modalOn: 'rgb(0, 0, 0)',
    modalBorder: 'rgb(77, 83, 93)',
    modalSurfaceBackground: 'rgb(185, 189, 197)',
    modalSurfaceOn: 'rgb(0, 0, 0)',
    modalSurfaceBorder: 'none',
    dialogBorderRadius: '',
    dialogHeaderBackground: 'rgb(208, 211, 216)',
    dialogHeaderOn: 'rgb(0, 0, 0)',
    dialogFooterBackground: 'rgb(208, 211, 216)',
    dialogFooterOn: 'rgb(0, 0, 0)',
    tooltipBackground: 'rgb(51, 51, 51)',
    tooltipOn: 'rgb(255, 255, 255)',
    tourBackground: 'rgb(185, 189, 197)',
    tourOn: 'rgb(0, 0, 0)',
    dataTableHeaderBackground: 'rgb(139, 146, 158)',
    dataTableHeaderOn: 'rgb(0, 0, 0)',
    dataTableHeaderHoverBackground: 'rgb(171, 176, 185)',
    dataTableHeaderHoverOn: 'rgb(0, 0, 0)',
    dataTableFooterBackground: 'rgb(139, 146, 158)',
    dataTableFooterOn: 'rgb(0, 0, 0)',
    dataTableRowOddBackground: 'rgba(247, 247, 247, 1)',
    dataTableRowOddOn: 'rgb(0, 0, 0)',
    dataTableRowEvenBackground: 'rgba(247, 247, 247, 1)',
    dataTableRowEvenOn: 'rgb(0, 0, 0)',
    dataTableRowBorder: 'none',
    dataTableRowHoverBackground: 'rgba(244, 244, 244, 1)',
    dataTableRowHoverOn: 'rgb(0, 0, 0)',
    dataTableRowSelectedBackground: 'rgba(162, 168, 177, 1)',
    dataTableRowSelectedOn: 'rgb(0, 0, 0)',
    dataTableResizer: 'rgb(255, 255, 255)',
    dataTableActionIcon: 'inherit',
    dataTableActionIconSelected: 'inherit',
    dataTableActionIconHover: 'inherit',
    dataTableSortIcon: 'inherit',
    dataTableSortIconActive: 'rgba(227, 228, 231, 1)',
    dataTableNavigationIcon: 'inherit',
    dataTableNavigationIconHover: 'inherit',
    dataTableNavigationIconBackground: 'rgba(0,  0,  0, 0.1)',
    dataTableNavigationIconHoverBackground: 'rgba(0,  0,  0, 0.3)',
    dataTableBodyBackground: 'transparent',
    dataTableBodyOn: 'inherit',
    selectionComponentBackground: 'rgba(247, 247, 247, 1)',
    selectionComponentOn: 'rgb(0, 0, 0)',
    selectionComponentHoverBackground: 'rgba(244, 244, 244, 1)',
    selectionComponentHoverOn: 'rgb(0, 0, 0)',
    selectionComponentSelectedBackground: 'rgba(162, 168, 177, 1)',
    selectionComponentSelectedOn: 'rgb(0, 0, 0)',
    masterDetailResizer: 'rgb(185, 189, 197)',
    stepperNumberIndicatorBackground: 'rgba(0,  0,  0, 0.1)',
    stepperNumberIndicatorOn: 'inherit',
    stepperLineSeparator: 'rgba(0,  0,  0, 0.2)',
    progressBarBackground: 'rgba(0, 0 , 0, 0.15)',
    buttonBackground: 'rgba(247, 247, 247, 1)',
    buttonOn: 'rgb(0, 0, 0)',
    calendarBackground: 'rgb(208, 211, 216)',
    calendarOn: 'rgb(0, 0, 0)',
    calendarSelectedBackground: 'rgba(49, 67, 92, 1)',
    calendarSelectedOn: 'rgb(255, 255, 255)',
    calendarHoverBackground: 'rgba(0,  0,  0, 0.2)',
    calendarHoverOn: 'inherit',
    calendarDivider: 'rgba(0,  0,  0, 0.2)',
    calendarInactiveMonthBackground: 'none',
    calendarInactiveMonthOn: 'inherit',
    calendarActiveMonthBackground: 'rgba(0,  0,  0, 0.05)',
    calendarActiveMonthOn: 'inherit',
    timePickerBackground: 'rgb(208, 211, 216)',
    timePickerOn: 'rgb(0, 0, 0)',
    timePickerTimeUnitBackground: 'rgba(0,  0,  0, 0.05)',
    timePickerTimeUnitOn: 'inherit',
    timePickerActiveTimeUnitBackground: 'rgba(82, 114, 156, 1)',
    timePickerActiveTimeUnitOn: 'rgb(255, 255, 255)',
    timePickerKeypadBackground: 'rgba(0,  0,  0, 0.05)',
    timePickerKeypadOn: 'inherit',
    timePickerKeypadHoverBackground: 'rgba(0,  0,  0, 0.05)',
    timePickerKeypadHoverOn: 'inherit',
    administrativeLabelsTextFill: 'rgba(0, 0, 0, 1)',
    administrativeLabelsTextStroke: 'rgba(138.48372093023255, 145.92093023255808, 158.31627906976743, 1)',
    landscapeLabelsTextFill: 'rgba(0, 0, 0, 1)',
    landscapeLabelsTextStroke: 'rgba(138.48372093023255, 145.92093023255808, 158.31627906976743, 1)',
    landscapeManmadeAll: 'rgba(57.4, 79.79999999999998, 109.2, 1)',
    landscapeNaturalGeometry: 'rgba(68.87999999999998, 95.75999999999996, 131.04, 1)',
    landscapeNaturalTerrainGeometry: 'rgba(57.4, 79.79999999999998, 109.2, 1)',
    poiGeometry: 'rgba(82, 114, 156, 1)',
    poiLabelsTextFill: 'rgba(255, 255, 255, 1)',
    poiLabelsTextStroke: 'rgba(57.4, 79.79999999999998, 109.2, 1)',
    transitGeometryFill: 'rgba(82, 114, 156, 1)',
    transitLabelsTextFill: 'rgba(255, 255, 255, 1)',
    transitLabelsTextStroke: 'rgba(57.4, 79.79999999999998, 109.2, 1)',
    roadGeometry: 'rgba(227, 228, 231, 1)',
    roadLabelsTextFill: 'rgba(0, 0, 0, 1)',
    roadLabelsTextStroke: 'rgba(153.0153846153846, 156.65769230769237, 167.58461538461538, 1)',
    waterAll: 'rgba(23, 38, 60, 1)',
    waterLabels: 'rgba(208, 211, 216, 1)',
    skeletonBackground: 'rgb(254, 254, 255)',
    skeletonFill: 'rgb(254, 254, 255)',
    skeletonAnimationColor: 'rgb(254, 254, 255)',
    skeletonTextColor: 'rgb(0, 0, 0)',
    switchOnBackground: 'rgba(82,  114,  156, 1)',
    switchOffBackground: 'rgb(115, 124, 139)',
    fontName: 'fjalla-lato',
    fontFamilyHeaders: 'Fjalla-600, sans-serif',
    fontFamily: 'Lato-400, sans-serif',
    fontBase: '1rem Lato-400, sans-serif',
    textBase: '1rem',
    textScaling: '1.25',
    textXs: 'calc(1rem / (1.25 * 1.25))',
    textSm: 'calc(1rem / 1.25)',
    textMd: 'calc(1rem * 1.25)',
    textLg: 'calc(var(--text-md) * 1.25)',
    textXl: 'calc(var(--text-lg) * 1.25)',
    textXxl: 'calc(var(--text-xl) * 1.25)',
    textXxxl: 'calc(var(--text-xxl) * 1.25)',
    fontH1: 'var(--text-xxxl) Fjalla-600, sans-serif',
    fontH2: 'var(--text-xxl) Fjalla-600, sans-serif',
    fontH3: 'var(--text-xl) Fjalla-500, sans-serif',
    fontH4: 'var(--text-lg) Fjalla-500, sans-serif',
    fontH5: 'var(--text-md) Fjalla-500, sans-serif',
    fontH6: 'var(--text-base) Fjalla-400, sans-serif',
    mainDivider: 'rgba(0,  0,  0, 0.2)',
    surfaceDivider: 'rgba(0,  0,  0, 0.2)',
    modalDivider: 'rgba(0,  0,  0, 0.2)',
    modalSurfaceDivider: 'rgba(0,  0,  0, 0.2)',
    themeName: 'superlumin-light',
    themeType: 'light',
    dataTableRowActiveBackground: 'rgba(162, 168, 177, 1)',
    dataTableRowActiveOn: 'rgb(0, 0, 0)'
};
